<div class="main-container lg-view">
  <h3 class="header">Procedure Confirmation Requests</h3>
  <ng-container
    *ngIf="copilotProcedureRequests && copilotProcedureRequests.length !== 0"
  >
    <div class="procedure-list">
      <div
        class="procedure-container"
        *ngFor="let procedure of copilotProcedureRequests; let i = index"
      >
        <a
          mat-flat-button
          [href]="procedure.cloudConfirmationUrl"
          [ngClass]="{
            'panel-completed': procedure.isCompleted,
            'panel-pending': !procedure.isCompleted
          }"
        >
          <div class="procedure-details">
            <span class="procedure-name">{{
              procedure.procedureName
            }}</span>
            <span>{{
              procedure.assetName
            }}</span>
            <span>{{ 
              procedure.siteAddress
            }}</span>
            <span class="requested-on"
              [ngClass]="{
                pending: !procedure.isCompleted
              }"
              >request sent on
              {{ moment(procedure.requestSentOn).format("MM/DD/YYYY") }}</span
            >
            <ng-container *ngIf="!procedure.isCompleted">
              <span
                [ngClass]="{
                  pending: !procedure.isCompleted
                }"
              >
                waiting for confirmation</span
              >
            </ng-container>
            <ng-container *ngIf="procedure.isCompleted">
              <span
                [ngClass]="{
                  completed: procedure.isCompleted
                }"
                >confirmed on
                {{
                  moment(procedure.completedOn).format("MM/DD/YYYY")
                }}</span
              >
            </ng-container>
          </div>
          <div class="status">
            <ng-container *ngIf="!procedure.isCompleted">
              <span>
                <mat-icon class="svg-icon" [svgIcon]="'hourglass'"></mat-icon>
              </span>
            </ng-container>
            <ng-container *ngIf="procedure.isCompleted">
              <span>
                <mat-icon class="svg-icon" [svgIcon]="'double_check_mark'"></mat-icon>
              </span>
            </ng-container>
          </div>
        </a>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="!copilotProcedureRequests || copilotProcedureRequests.length === 0"
  >
    <div class="no-data-container">
      <h4 class="no-data-text">No pending procedure confirmation requests.</h4>
    </div>
  </ng-container>
</div>
